import { useEffect } from 'react';

 const useDetectTabCloseOnly = (onTabClose: () => void) => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('isRefresh', 'true');
    };

    const handleUnload = () => {
      const isRefresh = sessionStorage.getItem('isRefresh');

      if (isRefresh === 'true') {
        sessionStorage.removeItem('isRefresh');
      } else {
        onTabClose();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [onTabClose]);
}; 

export default useDetectTabCloseOnly